// extracted by mini-css-extract-plugin
module.exports = {"playerWrapper":"VideoPlayer_playerWrapper__3Fplm","playerOverlay":"VideoPlayer_playerOverlay__3paj-","reactPlayer":"VideoPlayer_reactPlayer__24are"};